module.exports = require('./lib/no-important.js');



//////////////////
// WEBPACK FOOTER
// ./~/aphrodite/no-important.js
// module id = 11
// module chunks = 35783957827783